import {
	HighlightStyle,
	LRLanguage,
	LanguageSupport,
} from "@codemirror/language";
import { styleTags, tags } from "@lezer/highlight";

/**
 * Uses Lezer from Codemirror to parse code and add styles and highlighting.
 * @module rYamlParser
 * @category Lib
 */
import type { CompletionSource } from "@codemirror/autocomplete";
import { parser } from "./rYaml.js";

export const QpHighlightStyle = HighlightStyle.define([
	{ tag: tags.keyword, class: "qp-keyword-color" },
	{ tag: tags.controlKeyword, class: "qp-keyword-no-text-color" },
	{ tag: tags.comment, class: "qp-modifier-color" },
	{ tag: tags.documentMeta, class: "qp-stack-modifier-color" },
]);

export const parserWithMetaData = parser.configure({
	name: "rYaml",
	props: [
		styleTags({
			Keyword: tags.keyword,
			NotText: tags.controlKeyword,
			BackgroundKeyword: tags.controlKeyword, // Style like a NotText
			Modifier: tags.comment,
			BackgroundModifier: tags.comment, // Style like a Modifier
			StackModifier: tags.documentMeta,
		}),
	],
});

export const ryamlLanguageViewer = LRLanguage.define({
	parser: parserWithMetaData,
});

export function rYamlParser(completions?: CompletionSource) {
	const languageSupport = new LanguageSupport(ryamlLanguageViewer);

	if (completions) {
		const autocompleteExtension = ryamlLanguageViewer.data.of({
			autocomplete: completions,
		});
		return [languageSupport, autocompleteExtension];
	}

	return languageSupport;
}